export type ReviewDiffFile = {
  path: string;
  lines: ReviewDiffLine[];
  additions: number;
  deletions: number;
};

export type ReviewDiffLine = {
  content: string;
  kind: 'addition' | 'collapsed' | 'context' | 'deletion' | 'hunk' | 'meta';
  newLine: number | null;
  oldLine: number | null;
};

export function parseReviewDiff(value: string): ReviewDiffFile[] {
  const files: ReviewDiffFile[] = [];
  let current: ReviewDiffFile | null = null;
  let oldLine = 0;
  let newLine = 0;
  for (const line of value.split('\n')) {
    if (line.startsWith('diff --git ')) {
      const destination = line.lastIndexOf(' b/');
      current = {
        path: destination >= 0 ? line.slice(destination + 3) : line.slice('diff --git '.length),
        lines: [],
        additions: 0,
        deletions: 0,
      };
      files.push(current);
      continue;
    }
    if (current === null) {
      if (line.length === 0) continue;
      current = { path: 'Review notes', lines: [], additions: 0, deletions: 0 };
      files.push(current);
    }
    const hunk = line.match(/^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@/);
    if (hunk) {
      const nextOldLine = Number(hunk[1]);
      const nextNewLine = Number(hunk[2]);
      const hiddenLines = current.lines.length === 0 ? nextOldLine - 1 : nextOldLine - oldLine;
      if (hiddenLines > 0) {
        current.lines.push({
          content: `${hiddenLines} unmodified ${hiddenLines === 1 ? 'line' : 'lines'}`,
          kind: 'collapsed',
          oldLine: null,
          newLine: null,
        });
      }
      oldLine = nextOldLine;
      newLine = nextNewLine;
      current.lines.push({ content: line, kind: 'hunk', oldLine: null, newLine: null });
    } else if (line.startsWith('+') && !line.startsWith('+++')) {
      current.lines.push({ content: line.slice(1), kind: 'addition', oldLine: null, newLine });
      current.additions += 1;
      newLine += 1;
    } else if (line.startsWith('-') && !line.startsWith('---')) {
      current.lines.push({ content: line.slice(1), kind: 'deletion', oldLine, newLine: null });
      current.deletions += 1;
      oldLine += 1;
    } else if (line.startsWith(' ')) {
      current.lines.push({ content: line.slice(1), kind: 'context', oldLine, newLine });
      oldLine += 1;
      newLine += 1;
    } else if (!line.startsWith('index ') && !line.startsWith('--- ') && !line.startsWith('+++ ')) {
      current.lines.push({ content: line, kind: 'meta', oldLine: null, newLine: null });
    }
  }
  return files;
}
